import { validateStopwatchTime, validateTimeInput } from "./validation";

describe("validateTimeInput", () => {
  it("should work", () => {
    expect(validateTimeInput("0000:45", true)).toBeFalsy();
    expect(validateTimeInput("0000.45", true)).toBeFalsy();
    expect(validateTimeInput("0000,45", true)).toBeFalsy();
    expect(validateTimeInput("10000,45", true)).toBeTruthy();
    expect(validateTimeInput("1000", true)).toBeTruthy();
    expect(validateTimeInput("00:45", true)).toBeTruthy();
    expect(validateTimeInput("00,45", true)).toBeTruthy();
    expect(validateTimeInput("00.45", true)).toBeTruthy();
    expect(validateTimeInput("00.", true)).toBeTruthy();
    expect(validateTimeInput("0", true)).toBeTruthy();
    expect(validateTimeInput(".5", true)).toBeTruthy();
    expect(validateTimeInput(",55", true)).toBeTruthy();
    expect(validateTimeInput(",55", false)).toBeTruthy();
    expect(validateTimeInput(".55", false)).toBeTruthy();
    expect(validateTimeInput("00:45", false)).toBeFalsy();
    expect(validateTimeInput("00.45", false)).toBeFalsy();
    expect(validateTimeInput("00,45", false)).toBeFalsy();
    expect(validateTimeInput("0:45", false)).toBeTruthy();
    expect(validateTimeInput("0,45", false)).toBeTruthy();
    expect(validateTimeInput("0.45", false)).toBeTruthy();
    expect(validateTimeInput("00.", false)).toBeFalsy();
    expect(validateTimeInput("00", false)).toBeFalsy();
    expect(validateTimeInput("0", false)).toBeTruthy();
    expect(validateTimeInput("1:45", false)).toBeTruthy();
    expect(validateTimeInput("1:6", false)).toBeFalsy();
    expect(validateTimeInput("11:6", true)).toBeFalsy();
    expect(validateTimeInput("11:555", false)).toBeFalsy();
  });
});

describe("validateStopwatchTime", () => {
  it("should work", () => {
    expect(validateStopwatchTime("0000:45")).toBeFalsy();
    expect(validateStopwatchTime("0000.45")).toBeFalsy();
    expect(validateStopwatchTime("0000,45")).toBeFalsy();
    expect(validateStopwatchTime("10000,45")).toBeFalsy();
    expect(validateStopwatchTime("1000")).toBeFalsy();
    expect(validateStopwatchTime("00:45")).toBeTruthy();
    expect(validateStopwatchTime("00,45")).toBeTruthy();
    expect(validateStopwatchTime("00.45")).toBeTruthy();
    expect(validateStopwatchTime("00.")).toBeTruthy();
    expect(validateStopwatchTime("0")).toBeTruthy();
    expect(validateStopwatchTime(".5")).toBeTruthy();
    expect(validateStopwatchTime(",55")).toBeTruthy();
    expect(validateStopwatchTime(",55")).toBeTruthy();
    expect(validateStopwatchTime(".55")).toBeTruthy();
    expect(validateStopwatchTime("0:45")).toBeTruthy();
    expect(validateStopwatchTime("0,45")).toBeTruthy();
    expect(validateStopwatchTime("0.45")).toBeTruthy();
    expect(validateStopwatchTime("0")).toBeTruthy();
    expect(validateStopwatchTime("1:45")).toBeTruthy();
    expect(validateStopwatchTime("1:6")).toBeFalsy();
    expect(validateStopwatchTime("11:6")).toBeFalsy();
    expect(validateStopwatchTime("11:555")).toBeFalsy();
  });
});
